import React, { Component } from 'react';
import { getUsers, deleteUser, hasOneOfPermissions } from '../../utility/account';
import { addMessage } from '../../actions/messages';
import WaitForState from '../WaitForState';
import { withRouter } from 'react-router';
import { withUser } from '../../utility/withUser';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

/**
 * Component for showing users list.
 *
 * @extends React.Component
 */
class Users extends Component {
  /** @inheritdoc */
  constructor(props) {
    super(props);
    this.state = {
      users: null,
      doneWorking: true,
      createAllowed: null,
      editAllowed: [],
      deleteAllowed: [],
    }
  }

  /**
   * Fetch users.
   */
  fetchUsers = () => {
    getUsers(0, 100, this.props.token, this.props.history, (response) => {
      if (response.status !== 200) {
        this.props.dispatch(addMessage('Fejl under hentning af brugere. Prøv venligst igen senere.', 'danger'));
        return;
      }

      response.json().then((data) => {
        this.setState({users: data.items});
      });
    });
  }

  /**
   * Fetch permission to create user.
   */
  fetchCreateAllowedPermission = () => {
    hasOneOfPermissions(this.props.user.id, ["create any user", "create admin user", "create supervisor user", "create advisor user"], this.props.token, this.props.history, (allowed) => {
      this.setState({createAllowed: allowed});
    });
  }

  /**
   * Fetch permission to edit/delete users.
   */
  fetchEditDeleteAllowedPermission = () => {
    var roles = [
      'admin',
      'supervisor',
      'advisor',
    ];
    var permissionsToCheck = [];
    roles.forEach((role) => {
      permissionsToCheck.push('modify any ' + role + ' user');
      permissionsToCheck.push('delete any ' + role + ' user');
    });
    permissionsToCheck.push('modify any user');
    permissionsToCheck.push('delete any user');
    permissionsToCheck.push('modify own user');
    permissionsToCheck.push('delete own user');

    hasOneOfPermissions(this.props.user.id, permissionsToCheck, this.props.token, this.props.history, (oneAllowed, allowed, response) => {
      if (response.status === 200) {
        var editAllowed = [];
        var deleteAllowed = [];
        roles.forEach((role) => {
          editAllowed[role] = allowed['modify any user'];
          deleteAllowed[role] = allowed['delete any user'];

          if (!editAllowed[role]) {
            editAllowed[role] = allowed['modify any ' + role + ' user'];
          }
          if (!deleteAllowed[role]) {
            deleteAllowed[role] = allowed['delete any ' + role + ' user'];
          }
        });

        editAllowed['own'] = allowed['modify own user'];
        deleteAllowed['own'] = allowed['delete own user'];

        this.setState({editAllowed: editAllowed, deleteAllowed: deleteAllowed});
      }
    });
  }

  /**
   * Does logged in user have permission to edit/delete user of the given role?
   */
  hasRolePermission = (permissionSet, user) => {
    if (user.id === this.props.user.id && permissionSet['own']) {
      return true;
    }

    var allowed = true;
    user.roles.forEach((role) => {
      if (!permissionSet[role]) {
        allowed = false;
      }
    });
    return allowed;
  }

  /**
   * Get roles as readable string, from user.
   */
  getReadableRoles = (roles) => {
    var roleMap = {
      admin: 'Administrator',
      supervisor: 'Vejleder',
      advisor: 'Frivillig',
    };

    var rolesMapped = [];
    roles.forEach((role) => {
      if (roleMap[role]) {
        rolesMapped.push(roleMap[role]);
      }
    });

    return rolesMapped.join(', ');
  }

  /**
   * Handle when clicking delete user.
   */
  handleDeleteUser = (userId) => {
    if (window.confirm('Er du sikker på at du vil slette brugeren?')) {
      this.setState({doneWorking: false});
      deleteUser(userId, this.props.token, this.props.history, (response) => {
        this.setState({doneWorking: true});
        if (response.status !== 200) {
          this.props.dispatch(addMessage('Fejl under sletning af bruger. Prøv venligst igen senere.', 'danger'));
          return;
        }
        this.setState({users: null});
      });
    }
  }

  /**
   * Handle when user clicks add user.
   */
  handleClickAddUser = () => {
    this.props.history.push('/settings/users/create');
  }

  /** @inheritdoc */
  componentDidMount = () => {
    this.fetchUsers();
    this.fetchCreateAllowedPermission();
    this.fetchEditDeleteAllowedPermission();
  }

  /** @inheritdoc */
  render() {
    return (
      <div className="tab-pane fade show active" id="users" role="tabpanel" aria-labelledby="users">
        <div className="widget">
          <h3 className="section-heading">Brugere</h3>
          {this.state.createAllowed && <div className="form-group">
            <button id="usersControlButton" className="btn btn-primary" onClick={this.handleClickAddUser}>Tilføj ny bruger</button>
          </div>}
          <WaitForState state={this.state} keys={['users']}>
            <table className="table table-striped">
              <thead>
                <tr>
                  <td>Navn</td>
                  <td>Rolle</td>
                  <td>E-mail</td>
                  <td>Handlinger</td>
                </tr>
              </thead>
              <tbody>
                {this.state.users && this.state.users.map((user) => {
                  var userEditLink = '/settings/users/' + user.id;
                  return (
                    <tr key={user.id}>
                      <td>{user.name}</td>
                      <td>{this.getReadableRoles(user.roles)}</td>
                      <td>{user.email}</td>
                      <td>{this.hasRolePermission(this.state.editAllowed, user) && <Link to={userEditLink}>Rediger</Link>}&nbsp;&nbsp;&nbsp;{this.hasRolePermission(this.state.deleteAllowed, user) && <a onClick={() => {this.handleDeleteUser(user.id);}} className="text-danger">Slet</a>} </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </WaitForState>
        </div>
      </div>
    );
  }
}

export default withRouter(withUser(connect()(Users)));



// WEBPACK FOOTER //
// ./src/components/Users/index.js